/**
 * Doserne magic-link verifier — landing page for /doserne/verifiser?token=xxx
 * Auto-submits token, sets JWT, redirects to home.
 */
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Shield, XCircle, ArrowRight } from "lucide-react";
import { useDoserneAuth, TOKEN_KEY } from "./doserneAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DoserneVerifyLink() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useDoserneAuth();
  const token = params.get("token");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) { setError("Ingen lenke funnet"); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/doserne/auth/verify-link`, {
          token,
          remember_me: true,
        });
        localStorage.setItem(TOKEN_KEY, data.access_token);
        await refresh();
        toast.success(`Velkommen, ${data.user.first_name || data.user.email}!`);
        navigate("/doserne", { replace: true });
      } catch (err) {
        setError(err?.response?.data?.detail || "Ugyldig eller utløpt lenke");
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen bg-[#fafaf7] flex flex-col items-center justify-center px-4">
      <div className="w-10 h-10 rounded-lg bg-slate-900 flex items-center justify-center mb-6">
        <Shield className="w-6 h-6 text-cyan-400" strokeWidth={2.5} />
      </div>
      {error ? (
        <div className="text-center max-w-sm" data-testid="verify-link-error">
          <XCircle className="w-10 h-10 text-red-500 mx-auto mb-3" />
          <h1 className="text-xl font-black text-slate-900 mb-2">{error}</h1>
          <p className="text-sm text-slate-500 mb-6">Be om en ny kode fra innloggingssiden.</p>
          <button
            onClick={() => navigate("/doserne/logg-inn", { replace: true })}
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-slate-900 text-sm font-semibold"
            style={{ color: "#fff" }}
            data-testid="back-to-login"
          >
            Til innlogging <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <div className="text-center" data-testid="verify-link-loading">
          <Loader2 className="w-8 h-8 animate-spin text-slate-400 mx-auto mb-3" />
          <p className="text-sm text-slate-500">Logger deg inn…</p>
        </div>
      )}
    </div>
  );
}
